import { Frown, MessageSquare } from "lucide-react";

import { Skeleton } from "shared/ui/shadcn/skeleton";

export const ChatViewStates = {
  Loading: () => (
    <div className="flex h-full grow flex-col">
      <div className="flex-1 space-y-4 p-4">
        <Skeleton className="h-16 w-3/4 rounded-lg" />
        <Skeleton className="h-12 w-1/2 rounded-lg" />
      </div>

      <div className="border-t p-4">
        <Skeleton className="h-10 w-full rounded-lg" />
      </div>
    </div>
  ),
  Empty: () => (
    <div className="flex h-full grow flex-col">
      <div className="flex flex-1 flex-col items-center justify-center gap-2 text-center text-black/50">
        <MessageSquare size={48} />
        <h2 className="typography-header-6 text-black">No messages yet</h2>
        <p className="typography-body-4">Be the first to break the ice!</p>
      </div>
    </div>
  ),
  Zero: () => (
    <div className="flex h-full grow flex-col items-center justify-center gap-2 text-center text-black/50">
      <MessageSquare size={48} />
      <h2 className="typography-header-6 text-black">Select a chat</h2>
      <p className="typography-body-4">
        Start a conversation by selecting a chat from the sidebar.
      </p>
    </div>
  ),
  Error: () => (
    <div className="flex h-full grow flex-col items-center justify-center gap-2 text-center text-black/50">
      <Frown size={48} />
      <h2 className="typography-header-6 text-black">An error occurred</h2>
      <p className="typography-body-4">
        Seems like the chat you are trying to access does not exist.
      </p>
    </div>
  ),
};
